// src/hooks/useVoice.ts
import { useState, useCallback } from 'react';

export const useVoice = () => {
    const [isRecording, setIsRecording] = useState(false);
    const [transcript, setTranscript] = useState("");

    const startListening = useCallback(() => {
        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        if (!SpeechRecognition) return;

        const recognition = new SpeechRecognition();
        recognition.lang = 'ar-SA';
        recognition.continuous = false;
        recognition.interimResults = false;

        recognition.onstart = () => setIsRecording(true);
        recognition.onend = () => setIsRecording(false);
        recognition.onresult = (event: any) => {
            const result = event.results[0][0].transcript;
            setTranscript(result);
        };

        recognition.onerror = (event: any) => {
            console.error("Speech Recognition Error:", event.error);
            setIsRecording(false);
            // Alert user about specific common errors
            if (event.error === 'not-allowed') {
                alert("يرجى السماح بالوصول للميكروفون.");
            } else if (event.error === 'network') {
                alert("خطأ في الشبكة، يرجى التحقق من الاتصال.");
            }
        };

        recognition.onnomatch = () => {
            console.warn("Speech Recognition: No match found.");
        };

        recognition.start();
    }, []);

    const stopListening = useCallback(() => {
        setIsRecording(false);
        // Recognition stops automatically due to continuous: false
    }, []);

    return {
        isRecording,
        transcript,
        startListening,
        stopListening
    };
};
